// EXRSIM semantic version — bumped manually when a release wave ships.
// Keep this in sync with package.json "version".
//   MAJOR: generational rewrite / breaking data-model change
//   MINOR: backward-compatible feature wave
//   PATCH: backward-compatible bug fix only
export const APP_VERSION = '2.4.0';
export const APP_VERSION_LABEL = `v${APP_VERSION}`;
